<template>
  <div class="mkt-kpi">
    <kpi-filter slot="filter" :game-data="mGameData" @on-add="visible = true" @on-down="downExcel" @on-change="filterData">
      <template #upload>
        <el-upload action="" :before-upload="importExcel" accept="application/vnd.ms-excel,.xls,.xlsx,.csv">
          <el-button style="margin-right: 10px" :loading="uploadLoading">导入运营KPI</el-button>
        </el-upload>
      </template>
    </kpi-filter>
    <div class="__table tasks-table">
      <Viewport v-model="marketKpiOptions.height">
        <vxe-grid v-bind="marketKpiOptions" ref="marketTable">
          <!-- 操作列 -->
          <template #operation="{ row }">
            <el-popconfirm title="您确认删除该kpi吗？" @confirm="delClick(row)">
              <el-button slot="reference" type="text">删除</el-button>
            </el-popconfirm>
            <el-button type="text" @click.prevent="editClick(row)" style="margin-left: 10px">修改</el-button>
          </template>
        </vxe-grid>
        <el-pagination
          class="pager"
          :total="total"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          :page-sizes="[10, 20, 30, 40, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          background
          @current-change="changePageIndex"
          @size-change="changePageSize"
        />
      </Viewport>
    </div>

    <el-dialog
      :visible.sync="visible"
      :title="title"
      width="540px"
      :close-on-click-modal="false"
      @close="bindGetData(false)"
      @open="bindGetData(true)"
    >
      <div class="kpi-form">
        <el-form label-width="120px">
          <el-form-item label="月份">
            <el-date-picker
              v-model="kpiStand.tdate"
              :picker-options="datetimeOption"
              :disabled="editble"
              type="month"
              placeholder="请选择月份"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="归属">
            <el-select v-model="kpiStand.ascription" :disabled="editble" filterable placeholder="请选择归属" style="width: 100%">
              <el-option :value="1" label="买量" :key="1"></el-option>
              <el-option :value="2" label="渠道" :key="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="中间件游戏">
            <el-select v-model="kpiStand.mgameId" :disabled="editble" filterable placeholder="请选择中间件游戏" style="width: 100%">
              <el-option :value="game.id" :label="game.name" v-for="(game, idx) in mGameData" :key="idx + 1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="平台">
            <el-select v-model="kpiStand.platform" :disabled="editble" placeholder="请选择平台" style="width: 100%">
              <el-option :value="platform.id" :label="platform.name" v-for="(platform, idx) in platformData" :key="idx + 1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合格标准" class="dubble-label">
            <span class="sub-label">月新增</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.createRoleNumPass"
              placeholder="1-999999999"
              :min="1"
              :max="999999999"
              :precision="0"
              style="width: 260px"
            />
            <span> 个</span>
          </el-form-item>
          <el-form-item label="" class="dubble-label">
            <span class="sub-label">月流水</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.monthSumMoneyPass"
              placeholder="0.01-999999999.99"
              :min="0"
              :max="999999999.99"
              :precision="2"
              style="width: 260px"
            />
            <span> 元</span>
          </el-form-item>
          <el-form-item label="" class="dubble-label">
            <span class="sub-label">月消耗</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.monthSumAmountPass"
              placeholder="0.01-999999999.99"
              :min="0.01"
              :max="999999999.99"
              :precision="2"
              style="width: 260px"
            />
            <span> 元</span>
          </el-form-item>

          <el-form-item label="" class="dubble-label">
            <span class="sub-label">月活跃衰减</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.monthMauDeclinePass"
              placeholder="0.01-99.99"
              :min="0.01"
              :max="99.99"
              :precision="2"
              style="width: 260px"
            />
            <span> %</span>
          </el-form-item>

          <el-form-item label="优秀标准" class="dubble-label">
            <span class="sub-label">月新增</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.createRoleNumExcellent"
              placeholder="1-999999999"
              :min="1"
              :max="999999999"
              :precision="0"
              style="width: 260px"
            />
            <span> 个</span>
          </el-form-item>
          <el-form-item label="" class="dubble-label">
            <span class="sub-label">月流水</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.monthSumMoneyExcellent"
              placeholder="0.01-999999999.99"
              :min="0.01"
              :max="999999999.99"
              :precision="2"
              style="width: 260px"
            />
            <span> 元</span>
          </el-form-item>
          <el-form-item label="" class="dubble-label">
            <span class="sub-label">月消耗</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.monthSumAmountExcellent"
              placeholder="0.01-999999999.99"
              :min="0.01"
              :max="999999999.99"
              :precision="2"
              style="width: 260px"
            />
            <span> 元</span>
          </el-form-item>

          <el-form-item label="" class="dubble-label">
            <span class="sub-label">月活跃衰减</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.monthMauDeclineExcellent"
              placeholder="0.01-99.99"
              :min="0.01"
              :max="99.99"
              :precision="2"
              style="width: 260px"
            />
            <span> %</span>
          </el-form-item>

          <el-form-item label="卓越标准" class="dubble-label">
            <span class="sub-label">月新增</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.createRoleNumOutstdanding"
              placeholder="1-999999999"
              :min="1"
              :max="999999999"
              :precision="0"
              style="width: 260px"
            />
            <span> 个</span>
          </el-form-item>
          <el-form-item label="" class="dubble-label">
            <span class="sub-label">月流水</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.monthSumMoneyOutstdanding"
              placeholder="0.01-999999999.99"
              :min="0.01"
              :max="999999999.99"
              :precision="2"
              style="width: 260px"
            />
            <span> 元</span>
          </el-form-item>
          <el-form-item label="" class="dubble-label">
            <span class="sub-label">月消耗</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.monthSumAmountOutstdanding"
              placeholder="0.01-999999999.99"
              :min="0.01"
              :max="999999999.99"
              :precision="2"
              style="width: 260px"
            />
            <span> 元</span>
          </el-form-item>

          <el-form-item label="" class="dubble-label">
            <span class="sub-label">月活跃衰减</span>
            <el-input-number
              :controls="false"
              v-model="kpiStand.monthMauDeclineOutstdanding"
              placeholder="0.01-99.99"
              :max="99.99"
              :precision="2"
              style="width: 260px"
            />
            <span> %</span>
          </el-form-item>
        </el-form>
      </div>
      <template slot="footer">
        <div class="m-foot">
          <el-button @click="visible = false">取消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="handleSubmit"> 确认 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { isArray, timeout } from '@/common/js/utils'

import { HOST_API } from '@/api/config'
import { platformData } from '../data/platformData.js'
import { marketKpiOptions } from '../data/opts.js'

import KpiFilter from './components/kpi-filter.vue'
import tableMixin from '../gamepayback/mixin_table'

import { getMiddleGameList } from '@/api/common.model'
import { addOrUpdateMarketingKpi, getKpiPage, importKpi, getMarketingKpi, delMarketingKpi } from '@/api/report.model'
import { div, mul } from '@/common/js/api.js'

const makeKpiForm = () => {
  return {
    tdate: null,
    mgameId: null,
    ascription: null,
    platform: 0

    /* elment-ui el-input-number 如果有默认值，那么会被改成这个组件设置的min，max，如果不设置可以显示为空 */
    // createRoleNumPass: null, // 合格月新增
    // monthSumMoneyPass: null, // 合格月流水
    // monthSumAmountPass: null, // 合格月消耗
    // createRoleNumExcellent: null, // 优秀创角数
    // monthSumMoneyExcellent: null, // 优秀月流水
    // monthSumAmountExcellent: null, // 优秀月消耗
    // createRoleNumOutstdanding: null, // 卓越创角数
    // monthSumMoneyOutstdanding: null, // 卓越月流水
    // monthSumAmountOutstdanding: null, // 卓越月消耗
    // monthMauDeclinePass: null, // 月活跃衰减（合格月）
    // monthMauDeclineExcellent: null, // 月活跃衰减（优秀月）
    // monthMauDeclineOutstdanding: null // 月活跃衰减（卓越月）
  }
}
export default {
  name: 'MarketKpi',
  mixins: [tableMixin],
  components: {
    KpiFilter
  },
  computed: {
    title() {
      return this.editble ? '修改KPI' : '新建KPI'
    }
  },
  data() {
    return {
      height: 0,
      columns: [],
      tableData: [],
      tableColumns: [],
      mGameData: [],
      projectGroupData: [],

      submitLoading: null,
      uploadLoading: false,
      visible: null,
      editble: null,
      kpiStand: makeKpiForm(),
      resultModel: null,
      success: 0,
      failure: 0,
      platformData,
      marketKpiOptions,
      datetimeOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  methods: {
    bindGetData(val) {
      if (!val) {
        this.editble = val
        timeout(300).then(() => {
          this.kpiStand = makeKpiForm()
        })
      }
    },
    importExcel(file) {
      if (this.uploadLoading) return
      this.uploadLoading = true
      importKpi({ file }).then((data) => {
        if (data) {
          this.failure = data.failTotal
          this.success = data.successTotal
          this.uploadLoading = false
          this.$confirm(`成功${this.success}条，失败${this.failure}条`, '导入结果', {
            confirmButtonText: this.failure ? '下载失败数据' : '知道了',
            showCancelButton: false,
            type: 'info'
          }).then(() => {
            if (this.failure) this.downFail()
            else this.resultOk()
          })
        }
      })

      return false
    },
    downExcel() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_ptom_roi_config`, '_blank')
    },
    downFail() {
      window.open(`${HOST_API}/api/ptom/xlssettings/kpi/downerror`, '_blank')
    },
    resultOk() {
      this.resultModel = false
      this.pageIndex = 1
      this.getData()
    },
    delClick({ mgameId, tdate, platform, ascription }) {
      delMarketingKpi({ mgameId, tdate, platform, ascription }).then((data) => {
        data && this.getData()
      })
    },
    editClick({ mgameId, tdate, platform, ascription }) {
      const newdate = moment(tdate).format('YYYY-MM-01')

      getMarketingKpi({ mgameId, tdate: newdate, platform, ascription }).then((data) => {
        if (data) {
          const { tdate, platform, ...kpiData } = data

          const kpiForm = {}
          for (const key in kpiData) {
            const formItem = kpiData[key]

            if (formItem) {
              kpiForm[key] = formItem
              if (key === 'monthMauDeclinePass') {
                kpiForm[key] = mul(kpiData.monthMauDeclinePass, 100)
              }
              if (key === 'monthMauDeclineExcellent') {
                kpiForm[key] = mul(kpiData.monthMauDeclineExcellent, 100)
              }
              if (key === 'monthMauDeclineOutstdanding') {
                kpiForm[key] = mul(kpiData.monthMauDeclineOutstdanding, 100)
              }
            }
          }

          this.kpiStand = { ...kpiForm, platform, tdate: newdate }
          this.visible = true
          this.editble = true
        }
      })
    },
    handleSubmit() {
      const {
        tdate,
        ascription,
        mgameId,
        platform,
        createRoleNumPass, // 合格月新增
        monthSumMoneyPass, // 合格月流水
        monthSumAmountPass, // 合格月消耗
        createRoleNumExcellent, // 优秀创角数
        monthSumMoneyExcellent, // 优秀月流水
        monthSumAmountExcellent, // 优秀月消耗
        createRoleNumOutstdanding, // 卓越创角数
        monthSumMoneyOutstdanding, // 卓越月流水
        monthSumAmountOutstdanding, // 卓越月消耗
        monthMauDeclinePass,
        monthMauDeclineExcellent,
        monthMauDeclineOutstdanding
      } = this.kpiStand
      const callFn = (data) => {
        this.submitLoading = false
        data && (this.visible = false)
        data && this.getData()
      }
      if (!tdate) return this.$message.error('月份不能为空！')
      if (!ascription) return this.$message.error('归属不能为空！')
      if (!mgameId) return this.$message.error('中间件游戏不能为空！')

      // 检查是否至少填写了一个标准指标
      const hasValues = [
        createRoleNumPass,
        monthSumMoneyPass,
        monthSumAmountPass,
        monthMauDeclinePass,
        createRoleNumExcellent,
        monthSumMoneyExcellent,
        monthSumAmountExcellent,
        monthMauDeclineExcellent,
        createRoleNumOutstdanding,
        monthSumMoneyOutstdanding,
        monthSumAmountOutstdanding,
        monthMauDeclineOutstdanding
      ].some((value) => value)

      if (!hasValues) {
        return this.$message.error('请至少填写一个标准指标！')
      }

      // 验证月新增递增关系
      const createRoleNums = [createRoleNumPass, createRoleNumExcellent, createRoleNumOutstdanding].filter((v) => v)
      if (createRoleNums.length > 1) {
        const sortedCreateRole = [...createRoleNums].sort((a, b) => a - b)
        if (JSON.stringify(createRoleNums) !== JSON.stringify(sortedCreateRole)) {
          return this.$message.error('合格目标、优秀目标、卓越目标的月新增需按递增填写')
        }
      }

      // 验证月流水递增关系
      const monthMoneys = [monthSumMoneyPass, monthSumMoneyExcellent, monthSumMoneyOutstdanding].filter((v) => v)
      if (monthMoneys.length > 1) {
        const sortedMoney = [...monthMoneys].sort((a, b) => a - b)
        if (JSON.stringify(monthMoneys) !== JSON.stringify(sortedMoney)) {
          return this.$message.error('合格目标、优秀目标、卓越目标的月流水需按递增填写')
        }
      }

      // 验证月消耗递增关系
      const monthAmounts = [monthSumAmountPass, monthSumAmountExcellent, monthSumAmountOutstdanding].filter((v) => v)
      if (monthAmounts.length > 1) {
        const sortedAmount = [...monthAmounts].sort((a, b) => a - b)
        if (JSON.stringify(monthAmounts) !== JSON.stringify(sortedAmount)) {
          return this.$message.error('合格目标、优秀目标、卓越目标的月消耗需按递增填写')
        }
      }

      // 验证月活跃衰减递减关系（值越小越好，卓越 < 优秀 < 合格）
      const mauDeclines = [monthMauDeclinePass, monthMauDeclineExcellent, monthMauDeclineOutstdanding].filter((v) => v)
      if (mauDeclines.length > 1) {
        const sortedDecline = [...mauDeclines].sort((a, b) => b - a) // 降序排列
        if (JSON.stringify(mauDeclines) !== JSON.stringify(sortedDecline)) {
          return this.$message.error('合格目标、优秀目标、卓越目标的月活跃衰减需按递减填写')
        }
      }

      const err = () => {
        this.submitLoading = false
      }
      this.submitLoading = true
      console.log('this.kpiStand output: ', this.kpiStand)
      const formParams = {
        ...this.kpiStand,
        platform,
        mGameId: this.kpiStand.mgameId,
        tdate: moment(this.kpiStand.tdate).format('YYYY-MM-01'),
        monthMauDeclinePass: monthMauDeclinePass ? div(monthMauDeclinePass, 100) : null,
        monthMauDeclineExcellent: monthMauDeclineExcellent ? div(monthMauDeclineExcellent, 100) : null,
        monthMauDeclineOutstdanding: monthMauDeclineOutstdanding ? div(monthMauDeclineOutstdanding, 100) : null
      }
      addOrUpdateMarketingKpi(formParams).then(callFn).catch(err)
    },
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getKpiPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.tableColumns = this.marketKpiOptions.columns
              this.marketKpiOptions.data = list.map((i) => {
                return {
                  ...i,
                  monthMauDeclinePass: i.monthMauDeclinePass ? mul(i.monthMauDeclinePass, 100) + '%' : '',
                  monthMauDeclineExcellent: i.monthMauDeclineExcellent ? mul(i.monthMauDeclineExcellent, 100) + '%' : '',
                  monthMauDeclineOutstdanding: i.monthMauDeclineOutstdanding ? mul(i.monthMauDeclineOutstdanding, 100) + '%' : ''
                }
              })
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    preloadData() {
      Promise.all([getMiddleGameList()]).then((data) => {
        const [mGameData] = data
        isArray(mGameData) && (this.mGameData = mGameData)
        isArray(mGameData) && this.getData({})
      })
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.mkt-kpi {
  height: 100%;

  .c-control-margin {
    display: inline-block;
    margin-left: 8px;
  }

  ::v-deep .el-input-number {
    .el-input__inner {
      text-align: left;
    }
  }

  .kpi-form {
    height: 460px;
    padding-right: 10px;
    overflow: auto;

    .dubble-label {
      .el-form-item__content {
        display: flex;
        .sub-label {
          text-align: right;
          font-size: 13px;
          margin-right: 4px;
          display: inline-block;
          width: 75px;
        }
      }
    }
  }

  .pager {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
